import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import HowItWorks from "@/components/site/HowItWorks";
import WhyDogs from "@/components/site/WhyDogs";
import CinematicBand from "@/components/site/CinematicBand";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <div className="bg-ink" data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <HowItWorks />
      <WhyDogs />
      <CinematicBand />
      <Footer />
    </div>
  );
}
